export default __webpack_public_path__ + "static/media/(9)-Florentinos.3a1dc4ac.jpg";